module.exports = __webpack_public_path__ + "static/media/Test_hq3x.67351a87.jpg";